module.exports = __webpack_public_path__ + "img/wzb-bg-btm.ada62e6e.png";